import React, { useState } from 'react';
import { Mail, Send, CheckCircle, RefreshCw } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const EmailTicketForm = ({ token, label = 'Enviar ticket por email', idPrefix = 'ticket' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [error, setError] = useState('');

  const send = async (e) => {
    e.preventDefault();
    if (!token || !email) return;
    setStatus('sending');
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/ticket-public/${token}/email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      const j = await res.json().catch(() => ({}));
      if (!res.ok) {
        const detail = Array.isArray(j.detail) ? 'Correo no válido' : j.detail;
        throw new Error(detail || 'No se pudo enviar');
      }
      setStatus('sent');
    } catch (err) {
      setError(err.message);
      setStatus('error');
    }
  };

  if (status === 'sent') {
    return (
      <div className="w-full flex items-center justify-center gap-2 text-green-700 bg-green-50 rounded-xl py-2.5 text-sm font-medium" data-testid={`${idPrefix}-email-sent`}>
        <CheckCircle size={16} /> Enviado a {email}
      </div>
    );
  }

  return (
    <form onSubmit={send} className="w-full space-y-1.5" data-testid={`${idPrefix}-email-form`}>
      <p className="text-xs text-gray-500 flex items-center gap-1.5"><Mail size={13} /> {label}</p>
      <div className="flex gap-2">
        <input
          type="email"
          required
          inputMode="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="correo@ejemplo.com"
          className="flex-1 min-w-0 h-10 px-3 rounded-lg border border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
          data-testid={`${idPrefix}-email-input`}
        />
        <button
          type="submit"
          disabled={status === 'sending'}
          className="h-10 px-4 rounded-lg bg-gray-900 text-white text-sm font-semibold flex items-center gap-1.5 disabled:opacity-50 transition-colors hover:bg-gray-800"
          data-testid={`${idPrefix}-email-send-btn`}
        >
          {status === 'sending' ? <RefreshCw size={14} className="animate-spin" /> : <Send size={14} />}
          Enviar
        </button>
      </div>
      {status === 'error' && <p className="text-xs text-red-600" data-testid={`${idPrefix}-email-error`}>{error}</p>}
    </form>
  );
};
